import BoostTag from '../boost-tag';

function GalleryCard({ icon, title, value, valueInUsd, boostTag }: GalleryCardProps) {
  return (
    <div className="bg-[#0C111D] bg-opacity-80 p-4 md:p-6 min-w-[180px] wide-mobile:min-w-[200px] md:min-w-[250px] rounded-xl GalleryCard relative">
      <img className="mb-2 md:mb-4 md:h-14 md:w-14 w-11 h-11" src={icon} />
      <div className="flex flex-col gap-1 md:gap-[6px]">
        <div className="text-sm text-white md:text-base text-opacity-60">{title}</div>
        <div className="wide-mobile:text-lg text-base font-medium md:text-[22px]">{value}</div>
        <div className="text-sm md:text-base">{valueInUsd}</div>
      </div>
      <div className="absolute flex flex-col gap-[1px] md:gap-1 right-2 top-2">
        {boostTag.map((tag) => (
          <BoostTag key={tag}>{tag}</BoostTag>
        ))}
      </div>
    </div>
  );
}
export interface GalleryCardProps {
  symbol: string;
  icon: string;
  title: string;
  value: string;
  valueInUsd: string;
  boostTag: Array<string>;
}

export default GalleryCard;
